import clsx from 'clsx'
import React from 'react'
import { useTranslation } from 'react-i18next'

import Separator from '@/components-latest/primitives/Separator'
import Text from '@/components-latest/primitives/Text'
import { Performance } from '@/ducks/performance/performance.types'

import Styles from './AcceptanceRate.module.scss'

interface IAcceptanceRage {
  received: number
  rejected: Performance
  accepted: Performance
  className?: string
}

const AcceptanceRate: React.FC<IAcceptanceRage> = ({
  received,
  rejected,
  accepted,
  className
}) => {
  const { t } = useTranslation()

  return (
    <div
      className={clsx(Styles.acceptanceRate, className)}
      data-testid="acceptance-rate">
      <div className={Styles.header}>
        <Text variant="nextTitle-1">{received}</Text>
        <Text variant="nextBody">
          {t('performance.acceptance-rate.total-recieved')}
        </Text>
      </div>
      <Separator />
      <div className={Styles.columns}>
        <div className={Styles.column}>
          <div className={Styles.stats}>
            <Text variant="nextTitle-3" className={Styles.accepted} asChild>
              <span>{accepted.count}</span>
            </Text>
            <Text variant="nextBody" weight="semiBold" asChild>
              <span>• {Number(accepted.percentage).toFixed(1)}%</span>
            </Text>
          </div>
          <Text variant="nextBody">
            {t('performance.acceptance-rate.accepted')}
          </Text>
        </div>
        <Separator orientation="vertical" className={Styles.separator} />
        <div className={Styles.column}>
          <div className={Styles.stats}>
            <Text variant="nextTitle-3" className={Styles.rejected} asChild>
              <span>{rejected.count}</span>
            </Text>
            <Text variant="nextBody" weight="semiBold" asChild>
              <span>• {Number(rejected.percentage).toFixed(1)}%</span>
            </Text>
          </div>
          <Text variant="nextBody">
            {t('performance.acceptance-rate.rejected')}
          </Text>
        </div>
      </div>
    </div>
  )
}

export default AcceptanceRate
